import * as React from 'react';
import { ProtectiveFunctionLocation } from '../models/protectiveFunctionLocation';

interface Props {
    location: ProtectiveFunctionLocation,
    size: {
        height: number,
        width: number
    },
    position: {
        top: number,
        left: number
    },
    zoom: number,
    onRightClick: (e: React.MouseEvent, location: ProtectiveFunctionLocation) => void
}

const EmptyConfiguration = (props: Props) => {

    const height = `${props.size.height * props.zoom}px`;
    const width = `${props.size.width * props.zoom}px`;
    const top = `${props.position.top * props.zoom}px`;
    const left = `${props.position.left * props.zoom}px`;
    return (
        <div
            className="empty-config-location"
            style={{ height, width, top, left }}
            onContextMenu={e => props.onRightClick(e, props.location)}
        />
    );
}

export default EmptyConfiguration;